module.exports = __webpack_public_path__ + "static/icalendar_url_2-15236b743a2a88c8a6ee041fb87a6c45.png";